import { Button, styled } from '@mui/material';

export const TogglePreviousButton = styled(Button)`
  transition: 0.2s;
  text-transform: none;
`;
